import React from 'react';
import Text from '../Typography/Text';
import { useAppContext } from '../../context/AppContext';
const ExternalTemplate = ({ children }) => {
  const { logo } = useAppContext();

  return (
    <div className="login-w">
      <div className="login-ls">
        <div className="login-fw">
          <div className="login-h">
            <img
              src={logo}
              alt="Logo"
              style={{ maxHeight: '100px', maxWidth: '350px' }}
            />
          </div>
          <div className="login-b">
            <div>{children}</div>
          </div>
          <div className="login-f">
            <Text variant="subtitle2" label="Powered by: Software Algo Solutions" />
          </div>
        </div>
      </div>
      <div className="login-rs"></div>
    </div>
  );
};

export default ExternalTemplate;
